<template>
  <urun-listesi-ekle :duzenle="listeDetay" @clear="duzenleSifirla" />
</template>

<script>
import { mapState } from "vuex";
import UrunListesiEkle from "../../../components/Modules/Urunler/UrunListesiEkle.vue";
export default {
  components: { UrunListesiEkle },
  name: "UrunListesiDuzenle",
  data() {
    return {
      urunListeStep: 1
    };
  },
  computed: {
    ...mapState({
      listeDetay: state => state.Urunler.UrunListeleri.listeDetay
    })
  },
  methods: {
    duzenleSifirla() {
      this.$emit("clear", false);
    }
  }
};
</script>

<style>
</style>